import { db } from "@/firebaseConfig";

const ordersTotalByTableCollection = db.collection("orders_total_by_table");

const saveOrderTotalByTable = async (id, data) => {
  ordersTotalByTableCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("OrderTotalByTable successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateOrderTotalByTable = async (id, data) => {
  ordersTotalByTableCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("OrderTotalByTable successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteOrderTotalByTable = async id => {
  ordersTotalByTableCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("OrderTotalByTable successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getOrderTotalByTableById = async id => {
  return ordersTotalByTableCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  ordersTotalByTableCollection,
  saveOrderTotalByTable,
  updateOrderTotalByTable,
  deleteOrderTotalByTable,
  getOrderTotalByTableById
};
